import axios from "axios";

export const API_BASE_URL = "https://swagger.navaantrix.com/swaggerjv";

const api = axios.create({
  // baseURL: "http://localhost:2011",
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach JWT automatically to every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default api;

/*import axi

const api = axios.create({
  baseURL: "http://localhost:2011",
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
*/
